import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../features/userSlice';
import appReducer from '../features/appSlice';
import newsReducer from '../features/newsSlice';

export default configureStore({
  reducer: {
    user: userReducer,
    app: appReducer,
    news: newsReducer,
  },
});
